/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const CreateTransmittalRecordInputDto = zod.object({
  "id": zod.string().uuid().nullish()
});

export type CreateTransmittalRecordInputDto = zod.input<typeof CreateTransmittalRecordInputDto>;
export type CreateTransmittalRecordInputDtoOutput = zod.output<typeof CreateTransmittalRecordInputDto>;
